import { FileTextOutlined, ClockCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { Button, List, Space, Tag, Typography } from "antd";
import Card from "../Card";
import useContracts from "../../hooks/apis/useContracts";
import { Contract } from "../../types";
import { Link } from "react-router-dom";
import DownloadContract from "../downloadContract";

const { Text } = Typography;

const ContractsCard = () => {
  const { data: contracts, isLoading: contractsLoading, error } = useContracts();

  if (contractsLoading) return null;
  if (error || !contracts || contracts.length === 0) return null;

  return (
    <Card title="قراردادها" Icon={FileTextOutlined} actions={null}>
      <List
        dataSource={contracts}
        renderItem={(contract: Contract) => (
          <List.Item>
            <Space orientation={"horizontal"} className="w-full justify-between">
              <Space orientation="horizontal">
                <Text strong>
                  {contract.title}
                  {' '}
                  {contract.status === "PENDING" ? (
                    <Tag className="md:mr-1" color="gold" icon={<ClockCircleOutlined />}>
                      در انتظار امضا
                    </Tag>
                  ) : (
                    <Tag className="md:mr-1" color="green" icon={<CheckCircleOutlined />}>
                      امضا شده
                    </Tag>
                  )}
                </Text>
              </Space> 
              {contract.status === "PENDING" ?
                <Link to={`/contracts/${contract.uuid}`}>

                  <Button
                    type={"primary"}
                    size="small"
                  >
                    {"مشاهده و امضا قرارداد"}
                  </Button>
                </Link> :
                <Tag>{new Date(contract.signedAt!).toLocaleDateString("fa-IR")}</Tag>
              }
            </Space>
          </List.Item>
        )}
      />
    </Card>
  );
};

export default ContractsCard;

